var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"research-report"},[_c('sn-header',{attrs:{"text":"逐月匹配研报数量"},on:{"change":_vm.onToggleStatusChange}}),_c('el-collapse-transition',[(_vm.conditionsShow)?_c('div',{staticClass:"conditions"},[(_vm.researchReportNumber)?_c('bar-chart',{attrs:{"data":_vm.researchReportNumber}}):_vm._e()],1):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }